/** Matches the video composer's full prompt editor. */
export const VIDEO_PROMPT_MAX_LENGTH = 10_000;

export function normalizeVideoPrompt(prompt: string): string {
  return prompt.trim().slice(0, VIDEO_PROMPT_MAX_LENGTH);
}
